export default __webpack_public_path__ + "static/media/orange-arrow.90212482.svg";